export default "<!-- vue hook -->\n<!-- ko stopBinding: true -->\n<div id=\"vueCreateAccount\">\n</div>\n<!-- /ko -->\n";